import { Injectable } from '@angular/core';
import { Message, PromptButton } from '../Models/chat-bot.model';
import { Context_failed_prompt_buttons, Issue_identified_prompt_buttons } from '../Models/chat-bot-data.model';
import { Config } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class ChatBotMapper {
  MapMessages(isUser: boolean, message?: string, chatId?, streamStop?, type?): Message {
    const updateMessage = new Message();
    if (isUser) {
      updateMessage.author = Config.USER;
      updateMessage.authorDisplayName = "User";
      updateMessage.content = message;
    } else {
      updateMessage.author = Config.BOT;
      updateMessage.authorDisplayName = "MeteredGPT";
      updateMessage.content = {};
      updateMessage.content.message = message;
      updateMessage.chatId = chatId;
      updateMessage.stopCursor = streamStop;
      updateMessage.type = type;
    }
    updateMessage.todayDate = new Date();

    return updateMessage;
  }

  GetPromptButtons(responseContent: any) {
    let suggestedReplies: PromptButton[] = [];
    if (responseContent.context_object && responseContent.context_object.issue && responseContent.context_object.issue.identified) {
      suggestedReplies = Issue_identified_prompt_buttons;
    }

    if (responseContent.context && responseContent.context.name.toLocaleLowerCase() === "fail") {
      suggestedReplies = Context_failed_prompt_buttons;
    }
    return suggestedReplies;
  }

  ContextMapper = {
    'issue_identification': 'Issue Identification',
    'issue_resolution': 'Issue Resolution',
    'external_resolution': 'External Resolution',
    'business': 'Business Use Case',
    'cgs': 'CGS Use Case',
    'environment': 'Environment'
  }
}
